module.exports = __webpack_public_path__ + "static/media/10@1920w.6feb7189.jpg";